<template>
  <div class="xwzxmain">
    <!-- 大图 -->
    <div class="bigbgi">
      <div class="midbgi">
      </div>
    </div>
    <div class="xwzxcont">

      <el-row>
        <el-col style="margin-right:20px" :span="5">
          <div class="cdtitle">新闻中心</div>
          <el-menu @select="handleSelect" :default-active="pageNum" class="xwzxcd  el-menu-vertical-demo"
            text-color="#000" active-text-color="#1D50A2">
            <el-menu-item index="1">中国国际环保展览会</el-menu-item>
            <!-- <el-menu-item index="2">展会同期论坛</el-menu-item> -->
            <!-- <el-menu-item index="3">展商推介</el-menu-item> -->
            <!-- <el-menu-item index="4">专精特新专栏</el-menu-item> -->
            <!-- <el-menu-item index="5">技术亮点</el-menu-item> -->
            <!-- <el-menu-item index="6">行业动态</el-menu-item> -->
            <el-menu-item index="7">国际交流</el-menu-item>
            <!-- <el-menu-item index="8">合作展会</el-menu-item> -->
            <!-- <el-menu-item index="9">院士论坛</el-menu-item> -->
             <el-menu-item index="10">出海专栏</el-menu-item>
          </el-menu>
          <div class="zcsj">
            展出时间
          </div>
          <div>
            <div class="rqys">
              <div class="greendian"></div>
              <div class="rcsj">
                2026年6月2日 9:00-17:00
              </div>
            </div>
            <div class="rqys">
              <div class="greendian"></div>
              <div class="rcsj">
                2026年6月3日 9:00-17:00
              </div>
            </div>
            <div class="rqys">
              <div class="greendian"></div>
              <div class="rcsj">
                2026年6月4日 9:00-16:00
              </div>
            </div>
            <div style="margin-bottom:30px" class="rcsj">
              （每日闭馆前1小时停止入场）
            </div>
          </div>
        </el-col>
        <el-col :span="18">
          <div class="bread">
            <div>
              <a href="https://www.ciepec-online.com:8086/">首页>></a>
            </div>
            <div>新闻中心>></div>
            <div>{{ menuName }}</div>
          </div>
          <div v-if="pageNum == 1">
            <div v-for="item in cd1.news.slice((currentPage - 1) * pagesize, currentPage * pagesize)" :key="item.id">
              <div class="newslist">
                <div class="newstime">
                  <div style="margin:0 20px;  text-align: center;">
                    <img src="../../assets/index/jinrujiantou.png" alt="">
                  </div>
                </div>
                <div class="news">
                  <div @click="xqdetail(item)" class="newstlt">
                    {{ item.title }}
                  </div>
                  <div class="">
                    <img style="width:380px;height:180px" :src="item.images" alt="">
                  </div>
                </div>
              </div>

              <el-divider></el-divider>
            </div>
            <!-- 分页 -->
            <div class="fyys">
              <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="currentPage" :page-size="pagesize" layout="total,  prev, pager, next "
                :total="cd1.news.length">
              </el-pagination>
            </div>

          </div>
          <div v-if="pageNum == 2">
            <div v-for="item in cd2.news.slice((currentPage - 1) * pagesize, currentPage * pagesize)" :key="item.id"
              class="newslist">
              <div class="newstime">
                <div
                  style="font-size: 24px;color: #2D67B6;letter-spacing: 0;line-height: 22px;font-weight: 600;margin:0 20px 20px 20px">
                  {{ item.time.slice(0, 4) }}</div>
                <div
                  style="font-size: 20px;color: #2D67B6;letter-spacing: 0;line-height: 22px;font-weight: 400;margin: 0 20px 40px 20px">
                  {{ item.time.slice(-5) }}</div>
                <div style="margin:0 20px;  text-align: center;">
                  <img src="../../assets/index/jinrujiantou.png" alt="">
                </div>
              </div>
              <div class="news">
                <div @click="xqdetail(item)" class="newstlt">
                  {{ item.title }}
                </div>
                <div class="newsdetail">
                  {{ item.abstract }}
                </div>
              </div>
              <div class="newsimg">
                <img style="width:380px;height:180px" :src="item.images" alt="">
              </div>
            </div>
            <!-- 分页 -->
            <!-- <div class="fyys">
              <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pagesize" layout="total,  prev, pager, next " :total="cd2.news.length">
              </el-pagination>
            </div> -->
          </div>
          <div v-if="pageNum == 7">
            <div v-for="item in cd7.news.slice((currentPage - 1) * pagesize, currentPage * pagesize)" :key="item.id">
              <div class="newslist">
                <div class="newstime">
                  <div style="margin:0 20px;  text-align: center;">
                    <img src="../../assets/index/jinrujiantou.png" alt="">
                  </div>
                </div>
                <div class="news">
                  <div @click="xqdetail(item)" class="newstlt">
                    {{ item.title }}
                  </div>
                  <div class="">
                    <img style="width:380px;height:180px" :src="item.images" alt="">
                  </div>
                </div>
              </div>

              <el-divider></el-divider>
            </div>
            <!-- 分页 -->
            <div class="fyys">
              <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="currentPage" :page-size="pagesize" layout="total,  prev, pager, next "
                :total="cd7.news.length">
              </el-pagination>
            </div>
          </div>
          <div v-if="pageNum == 10">
            <div v-for="item in cd10.news.slice((currentPage - 1) * pagesize, currentPage * pagesize)" :key="item.id">
              <div class="newslist">
                <div class="newstime">
                  <div style="margin:0 20px;  text-align: center;">
                    <img src="../../assets/index/jinrujiantou.png" alt="">
                  </div>
                </div>
                <div class="news">
                  <div @click="xqdetail(item)" class="newstlt">
                    {{ item.title }}
                  </div>
                  <div class="">
                    <img style="width:380px;height:180px" :src="item.images" alt="">
                  </div>
                </div>
              </div>

              <el-divider></el-divider>
            </div>
            <!-- 分页 -->
            <div class="fyys">
              <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="currentPage" :page-size="pagesize" layout="total,  prev, pager, next "
                :total="cd10.news.length">
              </el-pagination>
            </div>
          </div>

          <newsDetail :title="title" :data="content" :type="type" v-if="pageNum === 'xq'" />
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import newsDetail from '../newsDetail/index.vue'
export default {
  name: 'Xwzx',
  components: {
    newsDetail
  },
  data () {
    return {
      menuName: '中国国际环保展览会',
      pageNum: '1',
      content: '1212121',
      type: '',
      currentPage: 1,
      pagesize: 5,
      // 第一个菜单
      cd1: {},
      cd2: {}

    }
  },
  created () {
    // CIEPEC2026新增文章（显示在最前面）
    const newArticles = [
      {
        images: '../../../static/20260623/1.webp',
        title: '转型升级智创未来 共绘绿色发展新蓝图—— 第二十四届中国国际环保展览会在京隆重开幕',
        content: 'https://mp.weixin.qq.com/s/7YCX4-P_4B0o_FkMYXYgjA',
        time: '2026-06-23',
        type: 'lianjie',
        abstract: '转型升级智创未来 共绘绿色发展新蓝图'
      },
      {
        images: '../../../static/20260623/2.webp',
        title: '生态环保产业创新发展大会〡聚焦技术创新升级 赋能产业高质量发展',
        content: 'https://mp.weixin.qq.com/s/7kwDzTvmils8ZDAEjV1EMQ',
        time: '2026-06-23',
        type: 'lianjie',
        abstract: '聚焦技术创新升级 赋能产业高质量发展'
      },
      {
        images: '../../../static/20260623/3.webp',
        title: '圆桌对话深度复盘｜聚焦"十五五"价值重构 企业家解锁产业转型新路径',
        content: 'https://mp.weixin.qq.com/s/OaV_gZUwoS3KS7UNQH4zqA',
        time: '2026-06-23',
        type: 'lianjie',
        abstract: '聚焦"十五五"价值重构 企业家解锁产业转型新路径'
      },
      {
        images: '../../../static/20260623/4.webp',
        title: 'CIEPEC2026生态环境科技创新成果展区成功举办',
        content: 'https://mp.weixin.qq.com/s/feaLz3KCt8Vr6dSdpUJoLQ',
        time: '2026-06-23',
        type: 'lianjie',
        abstract: 'CIEPEC2026生态环境科技创新成果展区成功举办'
      },
      {
        images: '../../../static/20260623/5.webp',
        title: '共赴环保盛会，探索绿色合作——"走进CIEPEC2026"参观活动',
        content: 'https://mp.weixin.qq.com/s/unKXDH7zOnTgVAjpQvlxkQ',
        time: '2026-06-23',
        type: 'lianjie',
        abstract: '共赴环保盛会，探索绿色合作'
      },
      {
        images: '../../../static/20260623/6.webp',
        title: '丽水市首次参展中国国际环保展览会',
        content: 'https://mp.weixin.qq.com/s/FD0F_GsP8IpIaxmN17kRrg',
        time: '2026-06-23',
        type: 'lianjie',
        abstract: '丽水市首次参展中国国际环保展览会'
      },
      {
        images: '../../../static/20260623/7.webp',
        title: '"十五五"VOCs治理趋势与路径',
        content: 'https://mp.weixin.qq.com/s/H38Ty31qQxoIn-XDKk73Ug',
        time: '2026-06-23',
        type: 'lianjie',
        abstract: '"十五五"VOCs治理趋势与路径'
      },
      {
        images: '../../../static/20260623/8.webp',
        title: '聚焦减污降碳前沿，共筑绿色发展未来——2026年工业烟气控制与温室气体减排技术研讨会成功举办',
        content: 'https://mp.weixin.qq.com/s/LFe_NjritODArs4lgWPivQ',
        time: '2026-06-23',
        type: 'lianjie',
        abstract: '聚焦减污降碳前沿，共筑绿色发展未来'
      },
      {
        images: '../../../static/20260623/9.webp',
        title: '第八届城镇水环境综合治理技术交流会成功举办',
        content: 'https://mp.weixin.qq.com/s/1GsIxJfMHGQRYn9epTcUfA',
        time: '2026-06-23',
        type: 'lianjie',
        abstract: '第八届城镇水环境综合治理技术交流会成功举办'
      },
      {
        images: '../../../static/20260623/10.webp',
        title: '数智赋能生态监测 科技引领绿色发展——第八届生态环境监测技术交流会在京召开',
        content: 'https://mp.weixin.qq.com/s/lnVkPOwPiT9ipCCL8CkR1w',
        time: '2026-06-23',
        type: 'lianjie',
        abstract: '数智赋能生态监测 科技引领绿色发展'
      },
      {
        images: '../../../static/20260623/11.webp',
        title: '2026年噪声与振动控制行业研讨会在京举办',
        content: 'https://mp.weixin.qq.com/s/6VnzWfNzi-u1jiz_JG1ZBQ',
        time: '2026-06-23',
        type: 'lianjie',
        abstract: '2026年噪声与振动控制行业研讨会在京举办'
      },
      {
        images: '../../../static/20260623/12.webp',
        title: '媒体是服务大众的：环境类报纸期刊亮相展会',
        content: 'https://mp.weixin.qq.com/s/GSoFpBOKua4KqZkM11Sq9Q',
        time: '2026-06-23',
        type: 'lianjie',
        abstract: '环境类报纸期刊亮相展会'
      },
      {
        images: '../../../static/20260623/13.webp',
        title: 'CIEPEC2026，遇见"方寸之间的美丽中国"',
        content: 'https://mp.weixin.qq.com/s/PgsAqgMhguLjeTLvhIpfkA',
        time: '2026-06-23',
        type: 'lianjie',
        abstract: '遇见"方寸之间的美丽中国"'
      },
      {
        images: '../../../static/20260623/14.webp',
        title: '第二十四届中国国际环保展览会掠影',
        content: 'https://mp.weixin.qq.com/s/p-DQKQ8eb7_xpwNN4sAvQA',
        time: '2026-06-23',
        type: 'lianjie',
        abstract: '第二十四届中国国际环保展览会掠影'
      },
      {
        images: '../../../static/20260623/15.webp',
        title: '【展商心声】深耕创新赛道 聚力高质量发展——参加第二十四届国际环保展览会参展感悟',
        content: 'https://mp.weixin.qq.com/s/aU1uZKJOZp-W8ARvukrg5Q',
        time: '2026-06-23',
        type: 'lianjie',
        abstract: '深耕创新赛道 聚力高质量发展'
      },
      {
        images: '../../../static/20260623/16.webp',
        title: '《中国环境保护产业发展报告（2025）》发布',
        content: 'https://mp.weixin.qq.com/s/jr8UAaWe03xNoV60sTR4pw',
        time: '2026-06-23',
        type: 'lianjie',
        abstract: '《中国环境保护产业发展报告（2025）》发布'
      }
    ]

    this.cd1 = {
      news: [
        ...newArticles,
        {
          images: '../../../static/2025042101/封面.png',
          title: '“科技水务”获点赞！粤海水务首次亮相中国国际环保展受广泛关注好评',
          content: '../../../static/2025042101/“科技水务”获点赞！粤海水务首次亮相中国国际环保展受广泛关注好评.png',
          time: '2025-04-21',
          type: 'image',
          abstract: '“科技水务”获点赞！粤海水务首次亮相中国国际环保展受广泛关注好评'
        },
        {
          images: '../../../static/2025042102/封面.png',
          title: 'CIEPEC2025生态环境科技创新成果展区成功举办',
          content: '../../../static/2025042102/CIEPEC2025生态环境科技创新成果展区成功举办.png',
          time: '2025-04-21',
          type: 'image',
          abstract: 'CIEPEC2025生态环境科技创新成果展区成功举办'
        },
        {
          images: '../../../static/2025042103/封面.png',
          title: '东江环保携发展成果及未来战略亮相第二十三届中国国际环保展览会',
          content: '../../../static/2025042103/东江环保携发展成果及未来战略亮相第二十三届中国国际环保展览会.png',
          time: '2025-04-21',
          type: 'image',
          abstract: '东江环保携发展成果及未来战略亮相第二十三届中国国际环保展览会'
        },
        {
          images: '../../../static/2025042104/封面.png',
          title: '科技赋能生态 创新引领未来丨江苏省环保集团精彩亮相第二十三届中国国际环保展',
          content: '../../../static/2025042104/科技赋能生态 创新引领未来丨江苏省环保集团精彩亮相第二十三届中国国际环保展.png',
          time: '2025-04-21',
          type: 'image',
          abstract: '科技赋能生态 创新引领未来丨江苏省环保集团精彩亮相第二十三届中国国际环保展'
        },
        {
          images: '../../../static/2025042105/封面.png',
          title: '山东环保集团参展第二十三届中国国际环保展览会',
          content: '../../../static/2025042105/山东环保集团参展第二十三届中国国际环保展览会.png',
          time: '2025-04-21',
          type: 'image',
          abstract: '山东环保集团参展第二十三届中国国际环保展览会'
        },
        {
          images: '../../../static/2025042106/封面.png',
          title: '展会聚焦：中化环境修复亮相第二十三届中国国际环保展',
          content: '../../../static/2025042106/展会聚焦：中化环境修复亮相第二十三届中国国际环保展.png',
          time: '2025-04-21',
          type: 'image',
          abstract: '展会聚焦：中化环境修复亮相第二十三届中国国际环保展'
        },
        {
          images: '../../../static/2025042107/封面.png',
          title: '中核环境受邀参加第二十三届中国国际环保展览会暨第七届生态环保产业创新发展大会',
          content: '../../../static/2025042107/中核环境受邀参加第二十三届中国国际环保展览会暨第七届生态环保产业创新发展大会.png',
          time: '2025-04-21',
          type: 'image',
          abstract: '中核环境受邀参加第二十三届中国国际环保展览会暨第七届生态环保产业创新发展大会'
        },
        {
          images: '../../../static/2025042108/封面.png',
          title: '主流媒体聚焦报道 _ 中广核环保参加第二十三届中国国际环保展览会',
          content: '../../../static/2025042108/主流媒体聚焦报道 _ 中广核环保参加第二十三届中国国际环保展览会.png',
          time: '2025-04-21',
          type: 'image',
          abstract: '主流媒体聚焦报道 _ 中广核环保参加第二十三届中国国际环保展览会'
        },
        {
          images: '../../../static/top1/封面.png',
          title: '盛大开幕！第二十三届中国国际环保展在京启幕 众多环保新技术新成果亮相',
          content: '../../../static/top1/盛大开幕！第二十三届中国国际环保展在京启幕 众多环保新技术新成果亮相.png',
          time: '2025-04-18',
          type: 'image',
          abstract: '第二十三届中国国际环保展在京启幕 众多环保新技术新成果亮相'
        },
        {
          images: '../../../static/top2/封面.png',
          title: '践行“两山”理念   服务“双碳”战略——第二十三届中国国际环保展览会在北京成功举办',
          content: '../../../static/top2/conteent.png',
          time: '2025-04-18',
          type: 'image',
          abstract: '第二十三届中国国际环保展览会在北京成功举办'
        },
        {
          images: '../../../static/top3/封面.png',
          title: '第二十三届中国国际环保展览会尽显科技创新，国产AI环境监测助力气候变化研究',
          content: '../../../static/top3/第二十三届中国国际环保展览会尽显科技创新，国产AI环境监测助力气候变化研究.png',
          time: '2025-04-18',
          type: 'image',
          abstract: '第二十三届中国国际环保展览会尽显科技创新，国产AI环境监测助力气候变化研究'
        },
        {
          images: '../../../static/top4/封面.png',
          title: '甘肃绿色环保成果亮相中国国际环保展 签约战略合作协议共促产业创新',
          content: '../../../static/top4/甘肃绿色环保成果亮相中国国际环保展 签约战略合作协议共促产业创新.png',
          time: '2025-04-18',
          type: 'image',
          abstract: '甘肃绿色环保成果亮相中国国际环保展 签约战略合作协议共促产业创新'
        },
        {
          images: '../../../static/top5/封面.png',
          title: '杭州展团再次亮相第二十三届中国国际环保展览会',
          content: '../../../static/top5/杭州展团再次亮相第二十三届中国国际环保展览会.png',
          time: '2025-04-18',
          type: 'image',
          abstract: '杭州展团再次亮相第二十三届中国国际环保展览会'
        },
        {
          images: '../../../static/top6/封面.png',
          title: '航天凯天环保精彩亮相第23届中国国际环保展 中国气候变化事务特使刘振民莅临展位丨践行环保担当 擘画绿',
          content: '../../../static/top6/航天凯天环保精彩亮相第23届中国国际环保展 中国气候变化事务特使刘振民莅临展位丨践行环保担当 擘画绿.png',
          time: '2025-04-18',
          type: 'image',
          abstract: '航天凯天环保精彩亮相第23届中国国际环保展 中国气候变化事务特使刘振民莅临展位丨践行环保担当 擘画绿'
        },

        {
          images: '../../../static/top7/封面.png',
          title: '精彩回顾 _ 朝阳环境CIEPEC2025的绿色之旅圆满结束',
          content: '../../../static/top7/精彩回顾 _ 朝阳环境CIEPEC2025的绿色之旅圆满结束.png',
          time: '2025-04-18',
          type: 'image',
          abstract: '精彩回顾 _ 朝阳环境CIEPEC2025的绿色之旅圆满结束'
        },

        {
          images: '../../../static/top8/封面.png',
          title: '青岛，主宾市！第23届中国国际环保展4月10日在京启幕',
          content: '../../../static/top8/青岛，主宾市！第23届中国国际环保展4月10日在京启幕.png',
          time: '2025-04-18',
          type: 'image',
          abstract: '青岛，主宾市！第23届中国国际环保展4月10日在京启幕'
        },

        {
          images: '../../../static/top9/封面.png',
          title: '厦门展厅亮相第二十三届中国国际环保展',
          content: '../../../static/top9/厦门展厅亮相第二十三届中国国际环保展.png',
          time: '2025-04-18',
          type: 'image',
          abstract: '厦门展厅亮相第二十三届中国国际环保展'
        },

        {
          images: '../../../static/top10/封面.png',
          title: '上海环境集团受邀参加第二十三届中国国际环保展',
          content: '../../../static/top10/上海环境集团受邀参加第二十三届中国国际环保展.png',
          time: '2025-04-18',
          type: 'image',
          abstract: '上海环境集团受邀参加第二十三届中国国际环保展'
        },
        {
          images: '../../../static/top11/封面.png',
          title: '深圳能源携深能环保等企业亮相第二十三届中国国际环保展览会，以创新科技赋能绿色低碳发展',
          content: '../../../static/top11/深圳能源携深能环保等企业亮相第二十三届中国国际环保展览会，以创新科技赋能绿色低碳发展.png',
          time: '2025-04-18',
          type: 'image',
          abstract: '深圳能源携深能环保等企业亮相第二十三届中国国际环保展览会，以创新科技赋能绿色低碳发展'
        },
        {
          images: '../../../static/top12/封面.png',
          title: '市环境保护产业协会参加协办的2025年泰州环保产业推介暨泰兴高新区投资环境说明会在北京成功举行',
          content: '../../../static/top12/市环境保护产业协会参加协办的2025年泰州环保产业推介暨泰兴高新区投资环境说明会在北京成功举行.png',
          time: '2025-04-18',
          type: 'image',
          abstract: '市环境保护产业协会参加协办的2025年泰州环保产业推介暨泰兴高新区投资环境说明会在北京成功举行'
        },
        {
          images: '../../../static/top13/封面.png',
          title: '苏州环保创新成果闪耀国际舞台—— 苏州作为主宾市亮相第二十三届中国国际环保展系列报道之二',
          content: '../../../static/top13/苏州环保创新成果闪耀国际舞台—— 苏州作为主宾市亮相第二十三届中国国际环保展系列报道之二.png',
          time: '2025-04-18',
          type: 'image',
          abstract: '苏州环保创新成果闪耀国际舞台—— 苏州作为主宾市亮相第二十三届中国国际环保展系列报道之二'
        },
        {
          images: '../../../static/top14/封面.png',
          title: '潼南参加第二十三届中国国际环保展览会 分享绿色机遇 携手“碳”索未来',
          content: '../../../static/top14/潼南参加第二十三届中国国际环保展览会 分享绿色机遇 携手“碳”索未来.png',
          time: '2025-04-18',
          type: 'image',
          abstract: '潼南参加第二十三届中国国际环保展览会 分享绿色机遇 携手“碳”索未来'
        }, {
          images: '../../../static/top15/封面.png',
          title: '中国资环参加第二十三届中国国际环保展览会',
          content: '../../../static/top15/中国资环参加第二十三届中国国际环保展览会.png',
          time: '2025-04-18',
          type: 'image',
          abstract: '中国资环参加第二十三届中国国际环保展览会'
        },

        {
          images: '../../../static/12yue27rinews/第二十三届中国国际环保展览会主场服务及搭建项目比选结果公示.png',
          title: '第二十三届中国国际环保展览会主场服务及搭建项目比选结果公示',
          content: '../../../static/12yue27rinews/第二十三届中国国际环保展览会主场服务及搭建项目比选结果公示.png',
          time: '2024-12-27',
          type: 'image',
          abstract: '第二十三届中国国际环保展览会主场服务及搭建项目比选结果公示'
        },
        {
          images: '../../../static/tz.jpg',
          title: '关于邀请参加第二十三届中国国际环保展览会主场服务及搭建项目比选的函',
          content: '../../../static/tz.jpg',
          time: '2023-09-06',
          type: 'lianjie',
          abstract: '关于邀请参加第二十三届中国国际环保展览会主场服务及搭建项目比选的函'
        },
        {
          images: '../../../static/通知封面.jpg',
          title: '关于邀请参加第二十三届中国国际环保展览会和2025生态环保产业创新发展大会的函',
          content: '../../../static/content.jpg',
          time: '2023-09-06',
          type: 'image',
          abstract: '关于邀请参加第二十三届中国国际环保展览会和2025生态环保产业创新发展大会的函'
        }

      ],
      total: 2
    }
    this.cd2 = {
      news: [
        //   {
        //   images: 'https://www.ciepec-online.com/u/cms/www/xwy-images/3.jpg',
        //   title: '第二十一届中国国际环保展览会（CIPEC 2023） “新时代背景下环境技术发展” 分论坛成功举办',
        //   content: 'https://www.ciepec-online.com/u/cms/www/xwy-images/4.png',
        //   time: '2023-04-26',
        //   type: 'image',
        //   abstract: '第二十一届中国国际环保展览会（CIPEC 2023） “新时代背景下环境技术发展” 分论坛成功举办'
        // },
        // {
        //   images: 'https://www.ciepec-online.com/u/cms/www/xwy-images/3.jpg',
        //   title: '第二十一届中国国际环保展览会及第五届生态环保产业创新发展大会开幕',
        //   content: 'https://www.ciepec-online.com/u/cms/www/xwy-images/5.png',
        //   time: '2023-04-26',
        //   type: 'image',
        //   abstract: '第二十一届中国国际环保展览会及第五届生态环保产业创新发展大会开幕'
        // }
      ],
      total: 2
    }
    this.cd7 = {
      news: [
        {
          images: '../../../static/12yue27rinews/国际封面.png',
          title: '2025年国际环保展览及会议信息',
          content: '../../../static/12yue27rinews/2025年国际环保展览及会议信息.png',
          time: '2023-04-26',
          type: 'image',
          abstract: '2025年国际环保展览及会议信息'
        },
        {
          images: '../../../static/11yue18rinews/1/封面.jpg',
          title: '德国站_中国生态环保产业代表团与国家能源欧洲研究院、德国中国商会交流座谈',
          content: '../../../static/11yue18rinews/1/德国站_中国生态环保产业代表团与国家能源欧洲研究院、德国中国商会交流座谈.png',
          time: '2023-04-26',
          type: 'image',
          abstract: '德国站_中国生态环保产业代表团与国家能源欧洲研究院、德国中国商会交流座谈'
        },
        {
          images: '../../../static/11yue18rinews/2/封面.jpg',
          title: '德国站_互学互鉴 共促发展 中国生态环保产业代表团调研德国环保技术',
          content: '../../../static/11yue18rinews/2/德国站_互学互鉴 共促发展 中国生态环保产业代表团调研德国环保技术.png',
          time: '2023-04-26',
          type: 'image',
          abstract: '德国站_互学互鉴 共促发展 中国生态环保产业代表团调研德国环保技术'
        },
        {
          images: '../../../static/11yue13news/封面.jpg',
          title: '德国站 _ 中国生态环保产业代表团参观EEW垃圾焚烧发电项目并座谈交流',
          content: '../../../static/11yue13news/德国站 _ 中国生态环保产业代表团参观EEW垃圾焚烧发电项目并座谈交流.png',
          time: '2023-04-26',
          type: 'image',
          abstract: '德国站 _ 中国生态环保产业代表团参观EEW垃圾焚烧发电项目并座谈交流'
        },
        {
          images: '../../../static/11yue12news/封面.png',
          title: '德国站 _ 中国生态环保产业代表团参观宝马集团回收与拆解中心',
          content: '../../../static/11yue12news/德国站 _ 中国生态环保产业代表团参观宝马集团回收与拆解中心.png',
          time: '2023-04-26',
          type: 'image',
          abstract: '德国站 _ 中国生态环保产业代表团参观宝马集团回收与拆解中心'
        },

        {
          images: '../../../static/11yue11rinews/3/封面.webp',
          title: '德国站 _ 中国生态环保产业代表团与德国慕尼黑展览集团座谈交流',
          content: '../../../static/11yue11rinews/3/德国站 _ 中国生态环保产业代表团与德国慕尼黑展览集团座谈交流.png',
          time: '2023-04-26',
          type: 'image',
          abstract: '德国站 _ 中国生态环保产业代表团与德国慕尼黑展览集团座谈交流'
        },
        {
          images: '../../../static/11yue11rinews/2/封面.webp',
          title: '意大利站 _ 参观交流成果丰硕 出访生活丰富多彩',
          content: '../../../static/11yue11rinews/2/意大利站 _ 参观交流成果丰硕 出访生活丰富多彩.png',
          time: '2023-04-26',
          type: 'image',
          abstract: '意大利站 _ 参观交流成果丰硕 出访生活丰富多彩'
        },
        {
          images: '../../../static/11yue11rinews/1/封面.webp',
          title: '意大利站_中国环境保护产业协会与意大利展览集团签订战略合作协议',
          content: '../../../static/11yue11rinews/1/意大利站_中国环境保护产业协会与意大利展览集团签订战略合作协议.png',
          time: '2023-04-26',
          type: 'image',
          abstract: '意大利站_中国环境保护产业协会与意大利展览集团签订战略合作协议'
        },
        {
          images: '../../../static/11yue11rinews/4/封面.jpg',
          title: '意大利站 _ 国际绿色能源及环保展ECOMONDO盛大开幕 中国生态环保产业代表团参加大会开幕式',
          content: '../../../static/11yue11rinews/4/意大利站 _ 国际绿色能源及环保展ECOMONDO盛大开幕 中国生态环保产业代表团参加大会开幕式.png',
          time: '2023-04-26',
          type: 'image',
          abstract: '意大利站 _ 国际绿色能源及环保展ECOMONDO盛大开幕 中国生态环保产业代表团参加大会开幕式'
        },

        {
          images: '../../../static/附件三/五/20240704131826.png',
          title: '中国生态环保产业代表团新加坡、马来西亚出访五',
          content: '../../../static/附件三/五/五.png',
          time: '2023-04-26',
          type: 'image',
          abstract: '中国生态环保产业代表团新加坡、马来西亚出访五'
        },
        {
          images: '../../../static/附件三/四/20240704131535.png',
          title: '中国生态环保产业代表团新加坡、马来西亚出访四',
          content: '../../../static/附件三/四/四.png',
          time: '2023-04-26',
          type: 'image',
          abstract: '中国生态环保产业代表团新加坡、马来西亚出访四'
        },

        {
          images: '../../../static/附件三/三/20240704131347.png',
          title: '中国生态环保产业代表团新加坡、马来西亚出访三',
          content: '../../../static/附件三/三/三.png',
          time: '2023-04-26',
          type: 'image',
          abstract: '中国生态环保产业代表团新加坡、马来西亚出访三'
        },

        {
          images: '../../../static/附件三/二/20240704131156.png',
          title: '中国生态环保产业代表团新加坡、马来西亚出访二',
          content: '../../../static/附件三/二/二.png',
          time: '2023-04-26',
          type: 'image',
          abstract: '中国生态环保产业代表团新加坡、马来西亚出访二'
        },
        {
          images: '../../../static/附件三/一/展示页.png',
          title: '中国生态环保产业代表团新加坡、马来西亚出访一',
          content: '../../../static/附件三/一/一.png',
          time: '2023-04-26',
          type: 'image',
          abstract: '中国生态环保产业代表团新加坡、马来西亚出访一'
        }
      ]

    }
    this.cd10 = {
      news: [
        {
          images: '../../../static/20260507/1.png',
          title: '金科环境中标中东地区4套新水岛®产品，解决应急供水问题',
          content: 'https://mp.weixin.qq.com/s/KOJ6gBbFcAQvApgEjwFNOQ',
          time: '2025-04-21',
          type: 'lianjie',
          abstract: '金科环境中标中东地区4套新水岛®产品，解决应急供水问题'
        },
        {
          images: '../../../static/20260421/问卷.png',
          title: '中国环保企业出海情况与需求调查问卷',
          content: 'https://mp.weixin.qq.com/s/vN41RA4dwtbYQk6xwpuxuw',
          time: '2025-04-21',
          type: 'lianjie',
          abstract: '中国环保企业出海情况与需求调查问卷'
        },
        {
          images: '../../../static/20260421/expec.png',
          title: '谱育科技ICP-OES首次落地希腊AdBlue检测场景',
          content: 'https://mp.weixin.qq.com/s/Z93avuyMTbJ487rouhmeEA',
          time: '2025-04-21',
          type: 'lianjie',
          abstract: '谱育科技ICP-OES首次落地希腊AdBlue检测场景'
        },
        {
          images: '../../../static/2026041601/中科环保.png',
          title: '中科环保品牌焕新，国际化征程再提速',
          content: 'https://mp.weixin.qq.com/s/6L_qbYSKnpJugQ2mEH3Q3Q',
          time: '2025-04-21',
          type: 'lianjie',
          abstract: '中科环保品牌焕新，国际化征程再提速'
        },
        {
          images: '../../../static/2026041601/博汇特.png',
          title: '博汇特的出海之路：技术护航，深耕细作，驶向"一带一路"蓝海',
          content: 'https://mp.weixin.qq.com/s/g2njIjqlSISW9SG6EEMMuw',
          time: '2025-04-21',
          type: 'lianjie',
          abstract: '博汇特的出海之路：技术护航，深耕细作，驶向"一带一路"蓝海'
        },
        {
          images: '../../../static/2026041601/龙净环保.png',
          title: '刚果（金）水力资源与电力部部长率代表团到访龙净环保',
          content: 'https://mp.weixin.qq.com/s/-r6u-PhiWNRpjgaQvq342A',
          time: '2025-04-21',
          type: 'lianjie',
          abstract: '刚果（金）水力资源与电力部部长率代表团到访龙净环保'
        },
        {
          images: '../../../static/2026041601/盈峰环境.png',
          title: '盈峰环境迎土库曼斯坦政府高层代表团考察',
          content: 'https://mp.weixin.qq.com/s/_pM0_OAS6IYuX-73zJh-7g',
          time: '2025-04-21',
          type: 'lianjie',
          abstract: '盈峰环境迎土库曼斯坦政府高层代表团考察'
        },
        {
          images: '../../../static/2026041601/可迪尔.png',
          title: '以"中国智造"扬帆出海，谱写环保装备国际化新篇章',
          content: 'https://mp.weixin.qq.com/s/OCDFb3aIRkAueepZPrfR6Q',
          time: '2025-04-21',
          type: 'lianjie',
          abstract: '以"中国智造"扬帆出海，谱写环保装备国际化新篇章'
        },
        {
          images: '../../../static/2026041601/康恒环境.png',
          title: '从技术追赶到全球引领 康恒环境的"内生、外拓与智造"三重奏',
          content: 'https://mp.weixin.qq.com/s/8YuoI1jEpZwR0Hgby3HpNg',
          time: '2025-04-21',
          type: 'lianjie',
          abstract: '从技术追赶到全球引领 康恒环境的"内生、外拓与智造"三重奏'
        }
      ],
      total: 9
    }
  },
  methods: {
    handleSelect (key) {
      this.menuName = event.target.innerText.trim()
      this.pageNum = key
      this.currentPage = 1
    },
    xqdetail (item) {
      if (item.type === 'lianjie') {
        window.open(item.content, '_blank')
      } else {
        this.content = item.content
        this.type = item.type
        this.title = item.title
        this.pageNum = 'xq'
      }
    },
    // 初始页currentPage、初始每页数据数pagesize和数据data
    handleSizeChange (size) {
      this.pagesize = size
    },
    handleCurrentChange (currentPage) {
      this.currentPage = currentPage
    }
  }
}
</script>

<style scoped>
a {
  text-decoration: none;
  font-size: 16px;
  color: #fff;
}

.xwzxmain {
  width: 100%;
}

.bigbgi {
  background-image: url('../../assets/index/banner-2026.jpg');
  background-repeat: no-repeat;
  background-position: center top;
  background-size: cover;
  width: 100%;
  height: 0;
  padding-bottom: 27.87%;
  margin-bottom: 60px;
}
.midbgi {
  background-image: none;
  width: 100%;
}

.xwzxcont {
  width: 80%;
  margin: 0 auto;
}

.xwzxcd {
  background: url('../../assets/index/cebian2.png') no-repeat,
    linear-gradient(180deg, #ffffff 0%, #e4efff 100%);
  background-repeat: no-repeat;
  background-position: center bottom;
  background-size: 100%;
  /* height: 450px; 元素高度 */
  width: 100%;
}

.el-menu-item {
  text-align: center;
  font-size: 18px;
  color: #16181a;
  letter-spacing: -0px;
  text-align: center;
  font-weight: 400;
}

.el-menu-item.is-active {
  font-weight: bold;
  color: #1d50a2;
}

.cdtitle {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: -80px;
  height: 86px;
  color: #fff;
  font-size: 24px;
  color: #ffffff;
  letter-spacing: 0;
  text-align: center;
  font-weight: 700;
  background-image: url('../../assets/index/cebian1.png');
  /* 设置图片路径 */
  background-repeat: no-repeat;
  /* 背景图片不重复 */
  background-position: center;
  /* 背景图片居中 */
  background-size: cover;
  height: 80px;
  /* 元素高度 */
  /* width: 100%; */
}

.bread {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: -60px;
  opacity: 0.94;
  background-image: linear-gradient(90deg,
      rgba(14, 152, 121, 0) 0%,
      #0e9577 50%);
  height: 60px;
  width: 470px;
  float: right;
  font-size: 16px;
  color: #ffffff;
  letter-spacing: 0;
  font-weight: 500;
}

.xgtitle {
  width: 280px;
  margin-bottom: 10px;
  margin-top: 5px;
  overflow: hidden;
  /* 确保超出的内容会被裁剪 */
  white-space: nowrap;
  /* 确保文本在一行内显示 */
  text-overflow: ellipsis;
  /* 超出的文本部分显示为省略号 */
  font-size: 18px;
  color: #333333;
  line-height: 32px;
  font-weight: 400;
}

.newslist {
  display: flex;
  justify-content: space-around;
  align-items: center;

  height: 250px;
}

.newstime {}

.news {
  flex: 1;
}

.newstlt {
  width: 500px;
  font-size: 22px;
  color: #000000;
  letter-spacing: 0;
  line-height: 22px;
  font-weight: 600;
  cursor: pointer;
  margin: 20px 0;
  overflow: hidden;
  /* 确保超出的内容会被裁剪 */
  white-space: nowrap;
  /* 确保文本在一行内显示 */
  text-overflow: ellipsis;
  /* 超出的文本部分显示为省略号 */
}

.newsdetail {
  width: 600px;
  font-size: 18px;
  color: #333333;
  line-height: 32px;
  font-weight: 400;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 95px;
}

.newsimg {
  margin-top: 30px;
}

.address {
  opacity: 0.9;
  background: #eff5ff;
  font-size: 18px;
  color: #333333;
  line-height: 34px;
  font-weight: 400;
  padding: 10px;
}

.zcsj {
  margin: 20px 0;
  padding: 10px 0;
  background: #159a7e;
  font-size: 24px;
  color: #ffffff;
  letter-spacing: 0;
  line-height: 24px;
  text-align: center;
  font-weight: 600;
}

.rqys {
  display: flex;
  /* justify-content: space-between; */
  align-items: center;
  height: 40px;
}

.greendian {
  width: 10px;
  height: 10px;
  border-radius: 10px;
  background: #159a7e;
}

.rcsj {
  flex: 1;
  font-size: 18px;
  color: #333333;
  text-align: center;
  line-height: 18px;
  font-weight: 400;
}

.fyys {
  text-align: center;
  margin: 20px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/caidan/xwzx.vue